import logoSrc from "@/assets/icon.png";

type TprIconProps = {
  size?: "small" | "medium" | "large";
};

const sizeMap = {
  small: "w-6 h-6",
  medium: "w-10 h-10",
  large: "w-16 h-16",
};

const TprIcon = ({ size = "medium" }: TprIconProps) => {
  const iconSize = sizeMap[size] || sizeMap.medium;
  return <img src={logoSrc} alt="The Practice Rooms Logo" className={iconSize} />;
};

export default TprIcon;
